import { useState, useEffect } from "react";
import { EventProvider } from "./context/EventContext";
import { RatingProvider } from "./component/Rating/RatingContext.jsx";
import ScrollToTopButton from "./utility/ScrollToTopButton";
import AllRoutes from "./routes/AllRoutes";
import DebugRender from "./component/Debug/DebugRender.jsx";
import "./App.css";
import GoogleAnalytics from "./component/GoogleAnalytics";

function App() {
  return (
    <>
      <GoogleAnalytics />
      {/* <DebugRender label="App" /> */}
      <RatingProvider>
        <EventProvider>
          <div>
            <AllRoutes />
            <ScrollToTopButton />
          </div>
        </EventProvider>
      </RatingProvider>
    </>
  );
}

export default App;
